import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "container-full-1 bg-grey-50" }
const _hoisted_2 = { class: "s20 widget flex align-items-center px-1 py-5" }
const _hoisted_3 = { class: "s2_mobile h-100p px-7" }
const _hoisted_4 = { class: "rounded-100 overflow-hidden item active" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "s4_mobile h-100p px-2" }
const _hoisted_7 = { class: "mb-2" }
const _hoisted_8 = { class: "s3_mobile h-100p px-2" }
const _hoisted_9 = { class: "font-normal mb-5" }
const _hoisted_10 = { class: "s7_mobile h-100p px-5" }
const _hoisted_11 = {
  class: "h-60 rounded-100 position-relative",
  style: {"width":"100%","background-color":"rgba(var(--color-black-rgb), 0.1)"}
}
const _hoisted_12 = { class: "widget-floating py-0 text-xl flex-right" }
const _hoisted_13 = { class: "px-5 py-6 s16 widget" }
const _hoisted_14 = { class: "my-5" }
const _hoisted_15 = { class: "grid-filter6 mt-4 mb-0" }
const _hoisted_16 = { class: "form-field-floating reactive sm" }
const _hoisted_17 = { class: "form-field-floating sm" }
const _hoisted_18 = { class: "form-field-floating sm" }
const _hoisted_19 = ["value"]
const _hoisted_20 = { class: "form-field-floating reactive sm" }
const _hoisted_21 = { class: "form-field-floating reactive sm" }
const _hoisted_22 = { class: "form-field-floating reactive sm" }
const _hoisted_23 = { class: "form-field-floating reactive sm" }
const _hoisted_24 = { class: "form-field-floating sm" }
const _hoisted_25 = { class: "form-field-floating sm" }
const _hoisted_26 = { class: "py-6 s20" }
const _hoisted_27 = { class: "table separator skin1 sm selection" }
const _hoisted_28 = { class: "font-bold" }
const _hoisted_29 = { class: "font-bold" }
const _hoisted_30 = { class: "font-bold" }
const _hoisted_31 = { class: "text-sm text-grey-500" }
const _hoisted_32 = { class: "s14_mobile px-3" }
const _hoisted_33 = {
  key: 0,
  class: "alert alert-danger mb-4"
}
const _hoisted_34 = { class: "s4 pl-5 pr-7" }
const _hoisted_35 = { class: "w-100 margin-auto mb-5 widget flex-center rounded-15" }
const _hoisted_36 = { class: "single-chart s6" }
const _hoisted_37 = {
  viewBox: "0 0 36 36",
  class: "circular-chart statorange"
}
const _hoisted_38 = ["stroke-dasharray"]
const _hoisted_39 = {
  x: "18",
  y: "20.35",
  class: "percentage font-bold"
}
const _hoisted_40 = { class: "s14 px-4" }
const _hoisted_41 = { class: "font-medium" }
const _hoisted_42 = { class: "w-100 margin-auto mb-5 widget flex-center rounded-15" }
const _hoisted_43 = { class: "single-chart s6" }
const _hoisted_44 = {
  viewBox: "0 0 36 36",
  class: "circular-chart statorange"
}
const _hoisted_45 = ["stroke-dasharray"]
const _hoisted_46 = {
  x: "18",
  y: "20.35",
  class: "percentage font-bold"
}
const _hoisted_47 = { class: "s14 px-4" }
const _hoisted_48 = { class: "font-medium" }
const _hoisted_49 = { class: "w-100 margin-auto mb-5 widget flex-center rounded-15" }
const _hoisted_50 = { class: "single-chart s6" }
const _hoisted_51 = {
  viewBox: "0 0 36 36",
  class: "circular-chart statorange"
}
const _hoisted_52 = ["stroke-dasharray"]
const _hoisted_53 = {
  x: "18",
  y: "20.35",
  class: "percentage font-bold"
}
const _hoisted_54 = { class: "s14 px-4" }
const _hoisted_55 = { class: "font-medium" }
const _hoisted_56 = { class: "w-100 margin-auto mb-5 widget flex-center rounded-15" }
const _hoisted_57 = { class: "single-chart s6" }
const _hoisted_58 = {
  viewBox: "0 0 36 36",
  class: "circular-chart statorange"
}
const _hoisted_59 = ["stroke-dasharray"]
const _hoisted_60 = {
  x: "18",
  y: "20.35",
  class: "percentage font-bold"
}
const _hoisted_61 = { class: "s14 px-4" }
const _hoisted_62 = { class: "font-medium" }

import { useToastStore } from '@/stores/toast.store';
import { calculatePercentage, formatAmount } from '@/utils';
import axios from 'axios';
import moment from 'moment';
import { computed, inject, onMounted, reactive, ref, watch } from 'vue';
import { useRoute } from 'vue-router';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'CollectivitesMembresView',
  setup(__props) {

const toastStore = useToastStore();
    const BACKEND_URL = inject('BACKEND_URL');
    const route = useRoute();
    const startupInfos = reactive<{ salaires: any[] }>((route.meta as any).item.startup_infos);
    const collectivite = ref<any>((route.meta as any).item.collectivite);
    const importDatas = ref<any[]>((route.meta as any).item.collectivite.users as Array<any>);
    const filteredDatas = ref([] as Array<any>);
    const loading = ref(false);
    const errorMessage = ref('');
    const queryParams = reactive({
        pageNumber: 1
    });
    const pagination = reactive({
        total: 0,
        per_page: 5,
        last_page: 1
    });
    const filtersParams = reactive({
        name: '',
        statut: null,
        salaires: null,
        quotite_cessible_min: null,
        quotite_cessible_max: null,
        age_min: null,
        age_max: null,
        sexe: null,
        fonction: null
    });
    const paginatedImportDatas = ref([] as Array<any>);

    onMounted(() => {
        applyFilters();
        onPaginate(1);
    })

    watch(filtersParams, (oldValues, newValues) => {
        applyFilters();
        onPaginate(1);
    });

    const statsPersonnesActivesCount = computed(() => importDatas.value.filter(i => i.statut == 'Actif').length);
    const statsPersonnesActivesPercent = computed(() => {
        if (importDatas.value.length == 0) { return 0; }
        return (statsPersonnesActivesCount.value * 100) / importDatas.value.length;
    });

    const statsPersonnesRetraitesCount = computed(() => importDatas.value.filter(i => i.statut == 'Retraité').length);
    const statsPersonnesRetraitesPercent = computed(() => {
        if (importDatas.value.length == 0) { return 0; }
        return (statsPersonnesRetraitesCount.value * 100) / importDatas.value.length;
    });

    const statsPersonnesHommesCount = computed(() => importDatas.value.filter(i => i.sexe == 'M').length);
    const statsPersonnesHommesPercent = computed(() => {
        if (importDatas.value.length == 0) { return 0; }
        return (statsPersonnesHommesCount.value * 100) / importDatas.value.length;
    });

    const statsPersonnesFemmesCount = computed(() => importDatas.value.filter(i => i.sexe == 'F').length);
    const statsPersonnesFemmesPercent = computed(() => {
        if (importDatas.value.length == 0) { return 0; }
        return (statsPersonnesFemmesCount.value * 100) / importDatas.value.length;
    });

    const membersPercentage = computed(() => {
        const maxMembers = 50000; // Valeur par défaut pour la barre de progression
        return Math.min(100, calculatePercentage(collectivite.value.users_count, maxMembers));
    });

    function applyFilters() {
        let allDatas = importDatas.value;

        if (filtersParams.name) {
            allDatas = allDatas.filter(a => `${a.nom} ${a.prenom}`.toLowerCase().includes(filtersParams.name!));
        }
        if (filtersParams.statut) {
            allDatas = allDatas.filter(a => a.statut == filtersParams.statut);
        }
        if (filtersParams.sexe) {
            allDatas = allDatas.filter(a => a.sexe == filtersParams.sexe);
        }
        if (filtersParams.quotite_cessible_min && !isNaN(filtersParams.quotite_cessible_min)) {
            const quotite_cessible_min = parseFloat(filtersParams.quotite_cessible_min);
            allDatas = allDatas.filter(a => a.quotite_cessible_montant && !isNaN(a.quotite_cessible_montant) && a.quotite_cessible_montant >= quotite_cessible_min);
        }
        if (filtersParams.quotite_cessible_max && !isNaN(filtersParams.quotite_cessible_max)) {
            const quotite_cessible_max = parseFloat(filtersParams.quotite_cessible_max);
            allDatas = allDatas.filter(a => a.quotite_cessible_montant && !isNaN(a.quotite_cessible_montant) && a.quotite_cessible_montant <= quotite_cessible_max);
        }
        if (filtersParams.age_min) {
            const age_min = moment(filtersParams.age_min);
            if (age_min.isValid()) {
                allDatas = allDatas.filter(a => {
                    const date_naissance = moment(a.date_naissance);
                    return date_naissance.isValid() && date_naissance.isSameOrAfter(age_min);
                })
            }
        }
        if (filtersParams.age_max) {
            const age_max = moment(filtersParams.age_max);
            if (age_max.isValid()) {
                allDatas = allDatas.filter(a => {
                    const date_naissance = moment(a.date_naissance);
                    return date_naissance.isValid() && date_naissance.isSameOrBefore(age_max);
                })
            }
        }
        if (filtersParams.salaires) {
            const matchSalaire = startupInfos.salaires[filtersParams.salaires];
            if (matchSalaire) {
                allDatas = allDatas.filter(a => !isNaN(a.salaire) && parseFloat(a.salaire) >= parseFloat(matchSalaire.salaire_min) && parseFloat(a.salaire) <= parseFloat(matchSalaire.salaire_max));
            }
        }
        
        filteredDatas.value = allDatas;
    }

    function onPaginate(page: number) {
        queryParams.pageNumber = page;
        pagination.total = filteredDatas.value.length;
        pagination.last_page = Math.ceil(pagination.total / pagination.per_page);
        const start = (page - 1) * pagination.per_page;
        paginatedImportDatas.value =  filteredDatas.value.slice(start, start + pagination.per_page);
    }


return (_ctx: any,_cache: any) => {
  const _component_custom_pagination = _resolveComponent("custom-pagination")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _cache[38] || (_cache[38] = _createStaticVNode("<div class=\"page-space-40\"></div><h4 class=\"s7 font-semibold px-3 pb-5\">Collectivité / Membres <span class=\"text-sm text-grey-500\"></span></h4><div class=\"s13 flex-right gap-3 mt--2 mb-5 px-5\"><span class=\"btn shadow-200 white2\">Collectivités</span><span class=\"btn shadow-200 white2\">Membres</span></div>", 3)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("img", {
            src: collectivite.value.logo ? (_unref(BACKEND_URL) + '/assets/collectivites/' + collectivite.value.logo) : '/assets/logos/logo2.svg',
            width: "100%"
          }, null, 8, _hoisted_5)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("h4", _hoisted_7, _toDisplayString(collectivite.value.nom || ''), 1),
        _createElementVNode("h3", null, _toDisplayString(collectivite.value.rccm || 'N/A'), 1)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("h4", _hoisted_9, _toDisplayString(collectivite.value.users_count || 0) + " / 50000 Membres", 1),
        _cache[10] || (_cache[10] = _createElementVNode("span", { class: "tag-state warning stroke" }, "En cours", -1)),
        _cache[11] || (_cache[11] = _createElementVNode("span", { class: "tag-state notif stroke" }, "Actif", -1))
      ]),
      _cache[12] || (_cache[12] = _createElementVNode("div", { class: "s4_mobile h-100p px-3" }, [
        _createElementVNode("h4", { class: "font-normal" }, [
          _createTextVNode(" Date de souscription "),
          _createElementVNode("br", { class: "mb-2" }),
          _createElementVNode("b", { class: "text-2xl" }, "11 Janvier 2028")
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, "Membres " + _toDisplayString(collectivite.value.users_count ? Math.round((collectivite.value.users_count / 50000) * 100) : 0) + "%", 1),
          _createElementVNode("div", {
            class: "h-100p flex align-items-center justify-content-left rounded-100 text-2xl px-5 bg-pop-green",
            style: _normalizeStyle({ width: membersPercentage.value + '%' })
          }, _toDisplayString(collectivite.value.users_count || 0) + " / 50000 ", 5)
        ])
      ])
    ]),
    _cache[39] || (_cache[39] = _createElementVNode("div", { class: "clear-both h-20" }, null, -1)),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-input",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filtersParams.name) = $event)),
              name: "name",
              id: "name",
              placeholder: ""
            }, null, 512), [
              [_vModelText, filtersParams.name]
            ]),
            _cache[13] || (_cache[13] = _createElementVNode("label", { for: "name" }, "Nom, prénoms", -1))
          ]),
          _createElementVNode("div", _hoisted_17, [
            _withDirectives(_createElementVNode("select", {
              class: "form-input-select",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filtersParams.statut) = $event)),
              name: "statut",
              id: "statut"
            }, [...(_cache[14] || (_cache[14] = [
              _createElementVNode("option", { value: null }, "Tous les statuts", -1),
              _createElementVNode("option", { value: "Actif" }, "Actifs", -1),
              _createElementVNode("option", { value: "Retraité" }, "Retraités", -1)
            ]))], 512), [
              [_vModelSelect, filtersParams.statut]
            ]),
            _cache[15] || (_cache[15] = _createElementVNode("label", { for: "statut" }, [
              _createTextVNode("Statut "),
              _createElementVNode("b", { class: "color-danger" }, "*")
            ], -1))
          ]),
          _createElementVNode("div", _hoisted_18, [
            _withDirectives(_createElementVNode("select", {
              class: "form-input-select",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filtersParams.salaires) = $event)),
              name: "salaires",
              id: "salaires"
            }, [
              _cache[16] || (_cache[16] = _createElementVNode("option", { value: null }, "Tous les salaires", -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(startupInfos.salaires, (salaire, index) => {
                return (_openBlock(), _createElementBlock("option", {
                  value: index,
                  key: index
                }, _toDisplayString(_unref(formatAmount)(salaire.salaire_min) + ' - ' + _unref(formatAmount)(salaire.salaire_max)), 9, _hoisted_19))
              }), 128))
            ], 512), [
              [_vModelSelect, filtersParams.salaires]
            ]),
            _cache[17] || (_cache[17] = _createElementVNode("label", { for: "salaires" }, [
              _createTextVNode("Salaires "),
              _createElementVNode("b", { class: "color-danger" }, "*")
            ], -1))
          ]),
          _createElementVNode("div", _hoisted_20, [
            _withDirectives(_createElementVNode("input", {
              type: "number",
              class: "form-input",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((filtersParams.quotite_cessible_min) = $event)),
              name: "quotite_cessible_min",
              id: "quotite_cessible_min",
              placeholder: ""
            }, null, 512), [
              [_vModelText, filtersParams.quotite_cessible_min]
            ]),
            _cache[18] || (_cache[18] = _createElementVNode("label", { for: "quotite_cessible_min" }, "Quotité cessible >=", -1))
          ]),
          _createElementVNode("div", _hoisted_21, [
            _withDirectives(_createElementVNode("input", {
              type: "number",
              class: "form-input",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((filtersParams.quotite_cessible_max) = $event)),
              name: "quotite_cessible_max",
              id: "quotite_cessible_max",
              placeholder: ""
            }, null, 512), [
              [_vModelText, filtersParams.quotite_cessible_max]
            ]),
            _cache[19] || (_cache[19] = _createElementVNode("label", { for: "quotite_cessible_max" }, "Quotité cessible >=", -1))
          ]),
          _createElementVNode("div", _hoisted_22, [
            _withDirectives(_createElementVNode("input", {
              type: "date",
              class: "form-input",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((filtersParams.age_min) = $event)),
              name: "age_min",
              id: "age_min",
              placeholder: ""
            }, null, 512), [
              [_vModelText, filtersParams.age_min]
            ]),
            _cache[20] || (_cache[20] = _createElementVNode("label", { for: "age_min" }, "Age >=", -1))
          ]),
          _createElementVNode("div", _hoisted_23, [
            _withDirectives(_createElementVNode("input", {
              type: "date",
              class: "form-input",
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((filtersParams.age_max) = $event)),
              name: "age_max",
              id: "age_max",
              placeholder: ""
            }, null, 512), [
              [_vModelText, filtersParams.age_max]
            ]),
            _cache[21] || (_cache[21] = _createElementVNode("label", { for: "age_max" }, "Age <=", -1))
          ]),
          _createElementVNode("div", _hoisted_24, [
            _withDirectives(_createElementVNode("select", {
              class: "form-input-select",
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((filtersParams.sexe) = $event)),
              name: "sexe",
              id: "sexe"
            }, [...(_cache[22] || (_cache[22] = [
              _createElementVNode("option", { value: null }, "Tous les sexes", -1),
              _createElementVNode("option", { value: "M" }, "Masculin", -1),
              _createElementVNode("option", { value: "F" }, "Féminin", -1)
            ]))], 512), [
              [_vModelSelect, filtersParams.sexe]
            ]),
            _cache[23] || (_cache[23] = _createElementVNode("label", { for: "sexe" }, [
              _createTextVNode("Sexe "),
              _createElementVNode("b", { class: "color-danger" }, "*")
            ], -1))
          ]),
          _createElementVNode("div", _hoisted_25, [
            _withDirectives(_createElementVNode("select", {
              class: "form-input-select",
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((filtersParams.fonction) = $event)),
              name: "fonction",
              id: "fonction"
            }, [...(_cache[24] || (_cache[24] = [
              _createElementVNode("option", { value: null }, "Toutes les fonctions", -1)
            ]))], 512), [
              [_vModelSelect, filtersParams.fonction]
            ]),
            _cache[25] || (_cache[25] = _createElementVNode("label", { for: "fonction" }, [
              _createTextVNode("Fonction "),
              _createElementVNode("b", { class: "color-danger" }, "*")
            ], -1))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_26, [
        _createElementVNode("table", _hoisted_27, [
          _cache[28] || (_cache[28] = _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", null, [
                _createElementVNode("img", {
                  src: "/icons/icon-filter-none.svg",
                  class: "size-xxs mt--1",
                  alt: ""
                }),
                _createTextVNode(" Nom ")
              ]),
              _createElementVNode("th", null, [
                _createElementVNode("img", {
                  src: "/icons/icon-filter-none.svg",
                  class: "size-xxs mt--1",
                  alt: ""
                }),
                _createTextVNode(" Prénoms ")
              ]),
              _createElementVNode("th", null, [
                _createElementVNode("img", {
                  src: "/icons/icon-filter-none.svg",
                  class: "size-xxs mt--1",
                  alt: ""
                }),
                _createTextVNode(" Salaire brut ")
              ]),
              _createElementVNode("th", null, [
                _createElementVNode("img", {
                  src: "/icons/icon-filter-up.svg",
                  class: "size-xxs mt--1",
                  alt: ""
                }),
                _createTextVNode(" Quotité cessible ")
              ]),
              _createElementVNode("th", null, [
                _createElementVNode("img", {
                  src: "/icons/icon-filter-none.svg",
                  class: "size-xxs mt--1",
                  alt: ""
                }),
                _createTextVNode(" Contact ")
              ]),
              _createElementVNode("th", null, [
                _createElementVNode("img", {
                  src: "/icons/icon-filter-none.svg",
                  class: "size-xxs mt--1",
                  alt: ""
                }),
                _createTextVNode(" CpteFonctAg ")
              ]),
              _createElementVNode("th", null, [
                _createElementVNode("img", {
                  src: "/icons/icon-filter-none.svg",
                  class: "size-xxs mt--1",
                  alt: ""
                }),
                _createTextVNode(" Identifiant Agent ")
              ]),
              _createElementVNode("th", null, [
                _createElementVNode("img", {
                  src: "/icons/icon-filter-none.svg",
                  class: "size-xxs mt--1",
                  alt: ""
                }),
                _createTextVNode(" FonctionAg ")
              ]),
              _createElementVNode("th", null, [
                _createElementVNode("img", {
                  src: "/icons/icon-filter-none.svg",
                  class: "size-xxs mt--1",
                  alt: ""
                }),
                _createTextVNode(" CatégAg ")
              ]),
              _createElementVNode("th", null, [
                _createElementVNode("img", {
                  src: "/icons/icon-filter-none.svg",
                  class: "size-xxs mt--1",
                  alt: ""
                }),
                _createTextVNode(" Statut ")
              ]),
              _createElementVNode("th", null, [
                _createElementVNode("img", {
                  src: "/icons/icon-filter-none.svg",
                  class: "size-xxs mt--1",
                  alt: ""
                }),
                _createTextVNode(" Sexe ")
              ])
            ])
          ], -1)),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paginatedImportDatas.value, (dataRow, index) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: 'row_' + index,
                class: "text-grey-700 over-effect"
              }, [
                _createElementVNode("td", _hoisted_28, _toDisplayString(dataRow.nom), 1),
                _createElementVNode("td", null, _toDisplayString(dataRow.prenom), 1),
                _createElementVNode("td", _hoisted_29, _toDisplayString(_unref(formatAmount)(dataRow.salaire)) + " F CFA", 1),
                _createElementVNode("td", _hoisted_30, [
                  _createTextVNode(_toDisplayString(_unref(formatAmount)(dataRow.quotite_cessible_montant)) + " ", 1),
                  _cache[26] || (_cache[26] = _createElementVNode("br", null, null, -1)),
                  _createTextVNode(" (" + _toDisplayString(dataRow.quotite_cessible_pourcent) + "%)", 1)
                ]),
                _createElementVNode("td", _hoisted_31, [
                  _createTextVNode(_toDisplayString(dataRow.telephone) + " ", 1),
                  _cache[27] || (_cache[27] = _createElementVNode("br", null, null, -1)),
                  _createTextVNode(" " + _toDisplayString(dataRow.email), 1)
                ]),
                _createElementVNode("td", null, _toDisplayString(dataRow.cpte_fonct_ag), 1),
                _createElementVNode("td", null, _toDisplayString(dataRow.identifiant_ag), 1),
                _createElementVNode("td", null, _toDisplayString(dataRow.fonction_ag), 1),
                _createElementVNode("td", null, _toDisplayString(dataRow.categ_ag), 1),
                _createElementVNode("td", null, _toDisplayString(dataRow.statut), 1),
                _createElementVNode("td", null, _toDisplayString(dataRow.sexe), 1)
              ]))
            }), 128))
          ])
        ]),
        _cache[29] || (_cache[29] = _createElementVNode("div", { class: "clear-both h-15" }, null, -1)),
        _createElementVNode("div", _hoisted_32, [
          _createVNode(_component_custom_pagination, {
            modelValue: queryParams.pageNumber,
            "onUpdate:modelValue": [
              _cache[9] || (_cache[9] = ($event: any) => ((queryParams.pageNumber) = $event)),
              onPaginate
            ],
            total: pagination.total,
            "per-page": pagination.per_page,
            last_page: pagination.last_page
          }, null, 8, ["modelValue", "total", "per-page", "last_page"])
        ])
      ]),
      (errorMessage.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_33, _toDisplayString(errorMessage.value), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_34, [
      _createElementVNode("div", _hoisted_35, [
        _createElementVNode("div", _hoisted_36, [
          (_openBlock(), _createElementBlock("svg", _hoisted_37, [
            _cache[30] || (_cache[30] = _createElementVNode("path", {
              class: "circle-bg",
              d: "M18 2.0845\n                        a 15.9155 15.9155 0 0 1 0 31.831 \n                        a 15.9155 15.9155 0 0 1 0 -31.831"
            }, null, -1)),
            _createElementVNode("path", {
              class: "circle",
              "stroke-dasharray": statsPersonnesActivesPercent.value + ', 100',
              d: "M18 2.0845\n                        a 15.9155 15.9155 0 0 1 0 31.831 \n                        a 15.9155 15.9155 0 0 1 0 -31.831"
            }, null, 8, _hoisted_38),
            _createElementVNode("text", _hoisted_39, _toDisplayString(statsPersonnesActivesPercent.value) + "%", 1)
          ]))
        ]),
        _createElementVNode("div", _hoisted_40, [
          _createElementVNode("h3", _hoisted_41, _toDisplayString(statsPersonnesActivesCount.value), 1),
          _cache[31] || (_cache[31] = _createElementVNode("h6", { class: "font-medium" }, "Personnes actives", -1))
        ])
      ]),
      _createElementVNode("div", _hoisted_42, [
        _createElementVNode("div", _hoisted_43, [
          (_openBlock(), _createElementBlock("svg", _hoisted_44, [
            _cache[32] || (_cache[32] = _createElementVNode("path", {
              class: "circle-bg",
              d: "M18 2.0845\n                        a 15.9155 15.9155 0 0 1 0 31.831 \n                        a 15.9155 15.9155 0 0 1 0 -31.831"
            }, null, -1)),
            _createElementVNode("path", {
              class: "circle",
              "stroke-dasharray":  statsPersonnesRetraitesPercent.value + ', 100',
              d: "M18 2.0845\n                        a 15.9155 15.9155 0 0 1 0 31.831 \n                        a 15.9155 15.9155 0 0 1 0 -31.831"
            }, null, 8, _hoisted_45),
            _createElementVNode("text", _hoisted_46, _toDisplayString(statsPersonnesRetraitesPercent.value) + "%", 1)
          ]))
        ]),
        _createElementVNode("div", _hoisted_47, [
          _createElementVNode("h3", _hoisted_48, _toDisplayString(statsPersonnesRetraitesCount.value), 1),
          _cache[33] || (_cache[33] = _createElementVNode("h6", { class: "font-medium" }, "Personnes retraités", -1))
        ])
      ]),
      _createElementVNode("div", _hoisted_49, [
        _createElementVNode("div", _hoisted_50, [
          (_openBlock(), _createElementBlock("svg", _hoisted_51, [
            _cache[34] || (_cache[34] = _createElementVNode("path", {
              class: "circle-bg",
              d: "M18 2.0845\n                        a 15.9155 15.9155 0 0 1 0 31.831 \n                        a 15.9155 15.9155 0 0 1 0 -31.831"
            }, null, -1)),
            _createElementVNode("path", {
              class: "circle",
              "stroke-dasharray": statsPersonnesHommesPercent.value + ', 100',
              d: "M18 2.0845\n                        a 15.9155 15.9155 0 0 1 0 31.831 \n                        a 15.9155 15.9155 0 0 1 0 -31.831"
            }, null, 8, _hoisted_52),
            _createElementVNode("text", _hoisted_53, _toDisplayString(statsPersonnesHommesPercent.value) + "%", 1)
          ]))
        ]),
        _createElementVNode("div", _hoisted_54, [
          _createElementVNode("h3", _hoisted_55, _toDisplayString(statsPersonnesHommesCount.value), 1),
          _cache[35] || (_cache[35] = _createElementVNode("h6", { class: "font-medium" }, "Hommes", -1))
        ])
      ]),
      _createElementVNode("div", _hoisted_56, [
        _createElementVNode("div", _hoisted_57, [
          (_openBlock(), _createElementBlock("svg", _hoisted_58, [
            _cache[36] || (_cache[36] = _createElementVNode("path", {
              class: "circle-bg",
              d: "M18 2.0845\n                        a 15.9155 15.9155 0 0 1 0 31.831 \n                        a 15.9155 15.9155 0 0 1 0 -31.831"
            }, null, -1)),
            _createElementVNode("path", {
              class: "circle",
              "stroke-dasharray": statsPersonnesFemmesPercent.value + ', 100',
              d: "M18 2.0845\n                        a 15.9155 15.9155 0 0 1 0 31.831 \n                        a 15.9155 15.9155 0 0 1 0 -31.831"
            }, null, 8, _hoisted_59),
            _createElementVNode("text", _hoisted_60, _toDisplayString(statsPersonnesFemmesPercent.value) + "%", 1)
          ]))
        ]),
        _createElementVNode("div", _hoisted_61, [
          _createElementVNode("h3", _hoisted_62, _toDisplayString(statsPersonnesFemmesCount.value), 1),
          _cache[37] || (_cache[37] = _createElementVNode("h6", { class: "font-medium" }, "Femmes", -1))
        ])
      ])
    ]),
    _cache[40] || (_cache[40] = _createElementVNode("div", { class: "clear-both h-70" }, null, -1))
  ]))
}
}

})